import React from "react";
import { Link } from "react-router-dom";
import "../style/TermsOfUse.css";

const TermsOfUse = () => {
  return (
    <div className="terms-of-use-container">
      <div className="page-header">
        <h1 className="page-title">Terms of Use</h1>
      </div>
      <p className="effective-date">Effective Date: July 12, 2025</p>
      
      <div className="terms-content">
        <p className="intro-text">
          By accessing and using this website, you agree to the following Terms of Use. If you do not agree with these terms, please do not use the site.
        </p>

        <section className="terms-section">
          <h2>1. Informational Purposes Only</h2>
          <p>
            All content and tools provided on The Picky Kitty are for informational purposes only.
            We do not provide veterinary, nutritional, or medical advice. Always consult with a qualified veterinarian before making decisions about your cat's health or diet.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Affiliate Disclosure</h2>
          <p>
            Some links on this site are affiliate links, primarily through the Amazon Associates Program. This means we may earn a small commission if you click through and make a purchase, at no additional cost to you.
          </p>
          <p>
            We do not control or take responsibility for the content, practices, or privacy policies of third-party websites such as Amazon. You can read our <Link to="/amazon-disclosure" className="contact-link">Amazon Associate Program Disclosure</Link> for more information.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. Acceptable Use</h2>
          <p>By using this site, you agree not to:</p>
          <ul>
            <li>Misuse, disrupt, or attempt to gain unauthorized access to the website</li>
            <li>Copy, scrape, or reproduce the content, layout, or database of this site without permission</li>
            <li>Use any part of the site, including tools or data presentation, for commercial purposes without prior written consent</li>
          </ul>
          <p>
            While some product data may originate from public sources, the structure and presentation on The Picky Kitty are original and protected.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. Intellectual Property</h2>
          <p>
            All original content on The Picky Kitty, including text, images, branding, calculators, and data presentation, is the property of the site owner unless otherwise credited.
          </p>
          <p>
            You may not reuse, republish, or redistribute any content without written permission.
          </p>
        </section>

        <section className="terms-section">
          <h2>5. Data Sources and Fair Use</h2>
          <p>
            Some product data displayed on this site (e.g., names, ingredients, nutritional values) originates from publicly available sources provided by pet food brands or retailers. We do not claim ownership of such factual data.
          </p>
          <p>
            However, the way this data is collected, structured, organized, and presented - including filters, tools, and comparisons - is original to The Picky Kitty and may not be reused or reproduced without written permission.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Availability and Changes</h2>
          <p>
            We may update, modify, or discontinue any part of this website, including tools, features, or content, at any time and without notice.
          </p>
          <p>
            We make no guarantees regarding the availability, accuracy, or completeness of the information on this website.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Limitation of Liability</h2>
          <p>By using this website, you agree that The Picky Kitty is not liable for any damages, losses, or issues resulting from:</p>
          <ul>
            <li>Your reliance on the content or tools</li>
            <li>Third-party links or products</li>
            <li>Errors, inaccuracies, or technical disruptions</li>
          </ul>
          <p>
            You use the site at your own risk.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. Governing Law</h2>
          <p>
            These Terms are governed by the laws of the State of Texas, United States.
            Any disputes will be handled in the courts located in Texas.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. Contact</h2>
          <p>
            For any questions or concerns, you can reach us at: <a href="mailto:meow@thepickykitty.com" className="contact-link">meow@thepickykitty.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfUse; 